import React from 'react'
import { useTrans } from 'hooks'
import { ListingHead, Page, PowerBar } from 'components/organisms'
import styles from './ArchiviDocumentiTemplate.module.sass'
import { ArchivioDocumentiListingNode, PaginaNode } from '@gql/graphql'
import { Button, WContainer } from '@components/atoms'
import { DocumentiCard } from '@components/molecules'

interface Props {
  pagina?: PaginaNode
  documenti?: ArchivioDocumentiListingNode[]
  handleMore?: (event: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  powerBarItems?: {
    pk: number
    name: string
    selected: boolean
    url: string
  }[]
  loading?: boolean
  nextPageLength?: number
  linkNextPage?: string
  buttonUrl?: boolean
}

const ArchiviDocumentiTemplate = (props: Props) => {
  const {
    pagina = undefined,
    documenti = undefined,
    powerBarItems = [],
    handleMore = undefined,
    loading = false,
    nextPageLength = undefined,
    linkNextPage = undefined,
    buttonUrl = false,
  } = props

  console.log(documenti)

  const t = useTrans()
  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main className={styles.layout}>
        <ListingHead pagina={pagina} variant={powerBarItems.length ? 'archivio' : 'default'} />
        <PowerBar items={powerBarItems} />
        <WContainer>
          <div className={styles.main}>
            <div className={styles.list}>
              {documenti?.map((x, index) => (
                <DocumentiCard
                  documento={x}
                  className={styles.documentiCard}
                  pagina={pagina}
                  key={x.pk}
                />
              ))}
            </div>
            {nextPageLength > 0 && (
              <div className={styles.ctaBox}>
                <Button
                  label={t('Carica altri contenuti')}
                  variant="secondary"
                  onClick={handleMore}
                  loading={loading}
                  href={buttonUrl ? linkNextPage : null}
                />
              </div>
            )}
          </div>
        </WContainer>
      </main>
    </Page>
  )
}

export default ArchiviDocumentiTemplate
